import { memo } from "react";
import { sendUserInvite } from "../../../../../../actions/customer";

function Remainder({ emailId, showReminderModal, setShowReminderModal }) {
  const sendReminder = () => {
    setShowReminderModal(false);
    sendUserInvite({
      email: emailId,
    });
  };

  return (
    <div
      className={`modal fade Form-Wizard-modal ${
        showReminderModal ? "d-block show" : ""
      }`}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Reminder
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <p>Do you really want to send reminder to this user?</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-round btn-default"
              data-dismiss="modal"
              onClick={() => setShowReminderModal(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-round btn-primary"
              style={{ color: "black", fontWeight: "bold" }}
              onClick={() => {
                sendReminder();
              }}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(Remainder);
